export default {
  'menu.result.success': 'Success',
  'success.result.title': 'Submit Success',
  'success.result.subTitle': 'Submit form success!',
  'success.result.printResult': 'Print result',
  'success.result.projectList': 'Project List',
  'success.result.progress': 'Progress',
  'success.submitApplication': 'Submit Application',
  'success.leaderReview': 'Leader Review',
  'success.purchaseCertificate': 'Purchase Certificate',
  'success.safetyTest': 'Safety Test',
  'success.launched': 'Officially launched',
  'success.waiting': 'Waiting',
  'success.processing': 'Processing',
};
